if (!customElements.get('bp-store-faq')) {
  customElements.define('bp-store-faq', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('details');
        if (detail && this.contains(detail)) detail.open = true;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
